exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".game-mainstage[data-v-e196e03e]{min-height:60vh}.player-darts[data-v-e196e03e]{grid-area:player-darts;display:grid;grid-template-areas:\"dart1 dart2 dart3\";grid-template-columns:1fr 1fr 1fr}", ""]);

// exports
